var $ = jQuery;
export default function accordionEvents() {
    $('.acfw-checkout-ui-block').on('click', '.acfw-accordion > h3', toggleAccordionContent);
    /**
     * if oceanwp multi-checkout page option is enabled
     * @page checkout
     * @option multi-checkout
     * */
    if ($('#owp-checkout-timeline').length) {
        // Execute after element is visible
        waitForVisibleElement('#agcfw-redeem-gift-card').then(function () {
            correctAccordionContentMaxHeight();
        });
    }
    else {
        // if oceanwp multi-checkout page option is disabled
        setTimeout(correctAccordionContentMaxHeight, 500);
    }
}
function toggleAccordionContent() {
    // @ts-ignore
    var $accordions = $('#acfw-checkout-ui-block').find('.acfw-accordion');
    // @ts-ignore
    var $accordion = $(this).parent();
    var isShown = $accordion.hasClass('show');
    $accordions.removeClass('show');
    if (!isShown) {
        $accordion.addClass('show');
    }
    else {
        $accordion.removeClass('show');
    }
}
function correctAccordionContentMaxHeight() {
    var $block = $('.acfw-checkout-ui-block');
    $block.find('.acfw-accordion').each(function () {
        var _a;
        // @ts-ignore
        var $accordion = $(this);
        var $content = $accordion.find('.acfw-accordion-content');
        var height = (_a = $content.height()) !== null && _a !== void 0 ? _a : 0;
        var padding = 2 * parseInt(getComputedStyle($content[0]).fontSize);
        $accordion.find('.acfw-accordion-inner').css({ maxHeight: height + padding + 10 });
    });
}
function waitForVisibleElement(selector) {
    return new Promise(function (resolve) {
        var checkVisibility = setInterval(function () {
            var el = document.querySelector(selector);
            if (el && el.offsetWidth > 0 && el.offsetHeight > 0) {
                clearInterval(checkVisibility);
                resolve(el);
            }
        }, 100);
    });
}
